/**
 * Estado de un presupuesto como etiqueta de color — bloque 1 (2026-09-18).
 *
 * El color nunca va solo (`OD-0017 D-04`): la etiqueta lleva el nombre del
 * estado escrito. Los colores salen de los tokens semánticos que ya existen
 * (éxito, aviso, error, información), así que el modo oscuro viene dado.
 */
import type { EstadoDocumental, EstadoFactura, EstadoPresupuesto } from "../api/cliente";
import { t } from "../i18n/es";

export function InsigniaEstado({ estado }: { estado: EstadoPresupuesto }) {
  return <span className={`insignia insignia-${estado}`}>{t.presupuestos.estados[estado]}</span>;
}

/**
 * El estado de una factura, con la misma insignia que los presupuestos.
 *
 * `URS §28`: lo que se dice es el estado DOCUMENTAL (una factura ya
 * rectificada sigue `ISSUED` en la base), y si ese estado no se reconoce se
 * cae al de la base en vez de quedarse en blanco. Esto estaba escrito a mano
 * en la lista de facturas; aquí se escribe una vez.
 */
export function InsigniaFactura({ estado, respaldo }: { estado: EstadoDocumental; respaldo: EstadoFactura }) {
  return <span className={`insignia insignia-factura-${estado}`}>{t.facturas.estados[estado] ?? t.facturas.estados[respaldo]}</span>;
}
